import { hasKeys, includesValue } from '@/helpers/object'
import { THEMES, VARIANTS } from '@/components/_shared/Form/form-helper'

export const isValidSelectOptions = options => options.every(obj => hasKeys(obj, ['text', 'value']))

export default {
  value: {
    required: true,
  },
  id: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    required: true,
    validator: isValidSelectOptions,
  },
  isRequired: {
    type: Boolean,
    default: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  theme: {
    type: String,
    default: THEMES.default,
    validator(value) {
      return includesValue(THEMES, value)
    },
  },
  variant: {
    type: String,
    default: VARIANTS.default,
    validator(value) {
      return includesValue(VARIANTS, value)
    },
  },
}
